export default "__VITE_ASSET__CBtBfoJx__"